import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMyTeamsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetMyTeamsQuery = {
  __typename?: 'Query';
  myTeams: Array<{
    __typename?: 'Team';
    id: any;
    name: string;
    createdAt: any;
    updatedAt: any;
  }>;
};

export const GetMyTeamsDocument = gql`
  query GetMyTeams {
    myTeams {
      id
      name
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetMyTeamsQuery__
 *
 * To run a query within a React component, call `useGetMyTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTeamsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetMyTeamsQuery,
    GetMyTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMyTeamsQuery, GetMyTeamsQueryVariables>(
    GetMyTeamsDocument,
    options,
  );
}
export function useGetMyTeamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetMyTeamsQuery,
    GetMyTeamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMyTeamsQuery, GetMyTeamsQueryVariables>(
    GetMyTeamsDocument,
    options,
  );
}
export function useGetMyTeamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetMyTeamsQuery,
        GetMyTeamsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetMyTeamsQuery, GetMyTeamsQueryVariables>(
    GetMyTeamsDocument,
    options,
  );
}
export type GetMyTeamsQueryHookResult = ReturnType<typeof useGetMyTeamsQuery>;
export type GetMyTeamsLazyQueryHookResult = ReturnType<
  typeof useGetMyTeamsLazyQuery
>;
export type GetMyTeamsSuspenseQueryHookResult = ReturnType<
  typeof useGetMyTeamsSuspenseQuery
>;
export type GetMyTeamsQueryResult = Apollo.QueryResult<
  GetMyTeamsQuery,
  GetMyTeamsQueryVariables
>;
